import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import ConstCommon from '../../common/Const';
import withMarketPreOpen from '../../common/market-pre-open/withMarketPreOpen';
import { TYPE_DISABLE } from '../../common/sync-component/Const';
import { withSyncDragCode } from '../../common/sync-drag-code';
import Tab from '../../common/tab-timer';

import {
  getCodeFromQuery,
  getCurrentDate,
  getQueryParams,
  removeDragCode,
  isNotLoginOrExpired,
  syncComponentSelector,
} from '../../helpers/Common';
import CurrentState from '../../helpers/CurrentState';
import EventEmitter, {
  SHOW_GUEST_POPUP,
  SYNC_COMPONENT_SEARCH,
} from '../../helpers/EventEmitter';
import { handleExport } from '../../helpers/HandleExport';
import timeAndSaleService from '../../../core/services/Prices/TimeAndSale/TimeAndSaleService';

import {
  REDUCER_NAME,
  fetchDataTimeAndSale,
  fetchInfoTicker,
  subscribeRealtime,
  changeCode,
} from './reducer';
import Footer from '../../common/table/Footer';
import GroupButton from './top-content/group-button';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import './index.scss';
import ScrollComponent from './../../common/ScrollComponent';
import { Provider } from './../../common/ComponentIdContext';
import { ComponentNameProvider } from './../../common/ComponentNameContext';
import Search from './Search';
import TopInfoContent from './TopInfoContent';
import { Export } from '../../common/export';
import Content from './Content';
import PreRender from './../../common/PreRender';
import AutoReloadOnFocusBlurComponent from '../../../core/loading/AutoReloadOnFocusBlur';

class TimeAndSale extends AutoReloadOnFocusBlurComponent {
  constructor(props) {
    super(props);
    this.state = {
      isChart:
        CurrentState.get(
          ConstCommon.listComponent.TimeAndSales,
          'isChart',
          this.props.id,
        ) || false,

      currentTab:
        CurrentState.get(
          ConstCommon.listComponent.TimeAndSales,
          'tab',
          this.props.id,
        ) || 1,
    };
    const { changeCode, id } = this.props;
    const code = getCodeFromQuery(['stock', 'derivative']);
    if (code) {
      changeCode(code, id);
    }
  }

  reload() {
    const { fetchInfoTicker, fetchDataTimeAndSale, id, condition } = this.props;
    const { code } = condition;
    fetchInfoTicker(id, code);
    const params = { Code: code };
    fetchDataTimeAndSale(params, id);
  }

  componentDidMount() {
    const {
      fetchInfoTicker,
      fetchDataTimeAndSale,
      id,
      glContainer,
      condition,
    } = this.props;

    removeDragCode(glContainer);
    super.componentDidMount();

    MessageHub.subscribe(
      ChanelConfig.TickChanel,
      this.dispatchDataRealtimeTick,
    );
    MessageHub.subscribe(
      ChanelConfig.DerivativeChannel,
      this.dispatchDataRealtimeDerivative,
    );
    const { code } = condition;
    const params = { Code: code };
    const queryCode = getQueryParams('code');
    if (!queryCode) {
      fetchInfoTicker(id, code);
      fetchDataTimeAndSale(params, id);
    }
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    MessageHub.unsubscribe(
      ChanelConfig.TickChanel,
      this.dispatchDataRealtimeTick,
    );
    MessageHub.unsubscribe(
      ChanelConfig.DerivativeChannel,
      this.dispatchDataRealtimeDerivative,
    );
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, changeCode, id } = this.props;
    if (
      syncType === TYPE_DISABLE ||
      syncType !== data.syncType ||
      data.search.isIndex ||
      data.componentId === id
    ) {
      return;
    }
    changeCode(data.search, id);
  };

  dispatchDataRealtimeTick = data => {
    const { subscribeRealtime, id } = this.props;
    subscribeRealtime(data, id, 'organCode');
  };

  dispatchDataRealtimeDerivative = data => {
    const { subscribeRealtime, id } = this.props;
    subscribeRealtime(data, id, 'derivativeCode');
  };

  exportAction = () => {
    const { condition, user } = this.props;
    if (isNotLoginOrExpired(user)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }
    timeAndSaleService
      .exportTable({
        Code: condition.code,
      })
      .then(res => {
        const name = I18n.t('common.export.timesAndSales', {
          ticker: condition.displayCode,
          date: getCurrentDate(),
        });
        handleExport(res, name);
      });
  };

  getFilterText = () => {
    const { isChart } = this.state;
    if (isChart) {
      return I18n.t('timeAndSale.table');
    }

    return I18n.t('timeAndSale.chart');
  };

  toggleIsChart = e => {
    e.preventDefault();
    const { isChart } = this.state;
    const { id } = this.props;
    CurrentState.add(
      ConstCommon.listComponent.TimeAndSales,
      'isChart',
      !isChart,
      id,
    );
    this.setState({
      isChart: !isChart,
    });
  };

  changeTab = tab => {
    const { id } = this.props;
    CurrentState.add(ConstCommon.listComponent.TimeAndSales, 'tab', tab, id);
    this.setState({ currentTab: tab });
  };

  render() {
    const { currentTab } = this.state;
    const { id, isDerivatives, glContainer, component } = this.props;

    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ComponentNameProvider value={ConstCommon.listComponent.TimeAndSales}>
            <ScrollComponent
              appendStyle={{ maxHeight: component.height }}
              appendClassName="ts-wrapper"
            >
              <div className="px-20 pt-8 d-flex flex-column flex-fill h-100">
                <div className="d-flex flex-fill flex-column">
                  <div className="ts-top-navigation flex-shrink-0">
                    <div className="ts-top-navigation--left">
                      <div style={{ minWidth: 200, marginRight: 20 }}>
                        <Search />
                      </div>
                      <TopInfoContent />
                      <GroupButton />
                    </div>
                  </div>
                  <div className="ts-body d-flex flex-fill flex-column">
                    <div className="align-items-center d-flex justify-content-between mb-10 mt-10 flex-shrink-0">
                      <div className="top-nav">
                        <Tab
                          disableTabNormal={true}
                          currentTab={currentTab}
                          listTab="timeAndSale.tab"
                          changeTab={this.changeTab}
                        />
                      </div>

                      <div className="ts-top-navigation--right">
                        <a
                          onClick={this.toggleIsChart}
                          href="#"
                          className="btn btn-cus-nomal bg-b-color-3 mr-6"
                        >
                          {this.getFilterText()}
                        </a>
                        <Export exportAction={this.exportAction} />
                      </div>
                    </div>
                    <Content
                      currentTab={currentTab}
                      isChart={this.state.isChart}
                    />
                  </div>
                </div>
                {isDerivatives || (
                  <Footer
                    listTextLang={[
                      {
                        text: 'common.table.SIMPLE_TABLE_FOOTER_TEXT',
                      },
                    ]}
                  />
                )}
              </div>
            </ScrollComponent>
          </ComponentNameProvider>
        </Provider>
      </PreRender>
    );
  }
}

const mapStateToProps = (state, { id }) => {
  return {
    component: state[REDUCER_NAME].listMultiComponent[id].component,
    i18n: state.i18n,
    user: state.userInfo,
    condition: state[REDUCER_NAME].listMultiComponent[id].condition,
    isDerivatives:
      state[REDUCER_NAME].listMultiComponent[id].condition.isDerivatives,
    syncType: syncComponentSelector(
      state,
      ConstCommon.listComponent.TimeAndSales,
      id,
    ),
  };
};

const mapDispatchToProps = {
  fetchDataTimeAndSale,
  fetchInfoTicker,
  subscribeRealtime,
  changeCode,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withMarketPreOpen(),
  withSyncDragCode,
)(TimeAndSale);
